/* ==========================================================================
   Calendar > Prototype
   ========================================================================== */

const flatpickr = require('flatpickr').default;
const ConfirmDatePlugin = require('flatpickr/dist/plugins/confirmDate/confirmDate');
const config = require('./vendor/config');

const configureDefaultDateForRangeMode = rawDefaultDate => {
    try {
        if (rawDefaultDate) {
            const defaultDate = JSON.parse(rawDefaultDate);
            if (Array.isArray(defaultDate) && defaultDate.length === 2) {
                const start = defaultDate[0];
                const end = defaultDate[1];

                if (start >= 0 && end >= 0) {
                    return [new Date().fp_incr(start), new Date().fp_incr(start + end)];
                }
            }
        }
    } catch (e) {
        return undefined;
    }
    return undefined;
};

const configureDefaultDate = (actualDefaultDate, configuration) => {
    if (configuration.mode === 'range') {
        return configureDefaultDateForRangeMode(configuration.defaultDate) || actualDefaultDate;
    }

    return actualDefaultDate;
};

const calendar = {
    /* Add 3rd party library config to the instance config */
    setConfig: function Fn() {
        /* compose config for 3rd party library */
        const baseConfig = config(this.config.mode || 'range');
        this.fp = { ...baseConfig, ...this.config.fp };

        this.fp.defaultDate = configureDefaultDate(this.fp.defaultDate, this.config);

        /* force display 1 month if device is mobile */
        if (this.getDevice() === 'mobile') this.fp.showMonths = 1;

        /* Set language */
        setLanguage(this.config.context.language);

        /* Add Confirm plugin only for time modes */
        if (config(this.config.mode).enableTime) {
            this.fp.plugins = [
                new ConfirmDatePlugin({
                    confirmIcon: '',
                    confirmText: 'OK'
                })
            ];
        }

        return this;
    },

    getInput() {
        return this.input.getInput();
    },

    setActive() {
        return this.input.setActive();
    },

    init: function Fn() {
        /* Set the 3rd party library config */
        this.setConfig();

        // Set the link label-input
        this.input.setPairing();

        // Add listeners
        if (this.config.domEvents) this.addEventListener();

        // Create the 3rd party library instance
        this.fp = flatpickr(this.getInput(), this.fp);

        // Recalculate value if set to date
        this.value = this.get();

        // Set the input to active since we use default init dates
        if (this.fp.config.defaultDate.length > 0) this.setActive();

        return this;
    },

    getDevice: function Fn() {
        return this.config.context.device;
    },

    get: function Fn() {
        return this.fp.selectedDates;
    },

    getYear: function Fn() {
        return this.fp.currentYear;
    },

    getMonth: function Fn() {
        return this.fp.currentMonth;
    },

    setDate: function Fn(date = new Date()) {
        this.fp.setDate(date);

        return this;
    },

    enableDates: function Fn(dates = []) {
        this.fp.set('enable', dates);

        return this;
    },

    clear: function Fn() {
        this.fp.clear();

        return this;
    },

    addEventListener: function Fn() {
        /* Binding events */
        this.bindEvents();

        /* Passing our callback to 3rd party one */
        this.fp.onChange = this.onChange;

        return this;
    },

    onChange: function Fn() {
        /* Execute callbacks */
        if (this.config.onChange.length > 0) this.config.onChange.forEach(item => item.call(this, this));

        return this;
    },

    bindEvents: function Fn() {
        this.onChange = this.onChange.bind(this);

        return this;
    }
};

module.exports = calendar;

function setLanguage(language) {
    /* eslint-disable */
    // Import languages
    const { Spanish } = require('flatpickr/dist/l10n/es');
    const { German } = require('flatpickr/dist/l10n/de');
    const { French } = require('flatpickr/dist/l10n/fr');
    const { Russian } = require('flatpickr/dist/l10n/ru');
    const { Portuguese } = require('flatpickr/dist/l10n/pt');
    const { Finnish } = require('flatpickr/dist/l10n/fi');
    const { Italian } = require('flatpickr/dist/l10n/it');
    /* eslint-enable */

    // Languages config
    this.languages = {
        es: Spanish,
        pt: Portuguese,
        it: Italian,
        de: German,
        fr: French,
        br: Portuguese,
        fi: Finnish,
        mx: Spanish,
        ru: Russian
    };

    flatpickr.localize(this.languages[language]);
}
